import InputDropdown from "components/Input/Dropdown";
import Context from "context/Global";
import deferred from "deferred";
import { priceParser } from "helpers/StringParser";
import iconv from "iconv-lite";
import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { useDropzone } from "react-dropzone";
import Api from "services/Api/Api";
import styled from "styled-components/macro";
import XLSX from "xlsx";
import convert from "xml-js";
import Customer from "./Customer";
import { numberOfInvoicedShipments } from "./Helpers";
import CustomParser from "./Parser/custom";
import DHLParser from "./Parser/dhl";
import DSVParser from "./Parser/dsv";
import FedexParser from "./Parser/fedex";
import LemanParser from "./Parser/leman";
import TNTParser from "./Parser/tnt";
import UPSParser from "./Parser/ups";
import PostNordParser from "./Parser/postnord";
import toast from "react-hot-toast";
import BringParser from "./Parser/bring";
import FrejaParser from "./Parser/freja";
import FortnoxAuthenticator from "./Helpers/Auth/FortnoxAuthenticator";

let Container = styled.div`
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1em;

    > .dropInvoices {
        border: 2px dashed #ddd;
        color: #aaa;
        font-size: 2em;
        border-radius: 1em;
        width: 50%;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    > .summary {
        display: flex;
        padding: 1rem;
        width: 100%;
        padding: 1rem;

        > .title {
            margin-right: 2rem;
            width: 200px;
            font-weight: bold;
        }

        > .icon {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 2rem;
            position: relative;
            width: 8vw;

            > svg {
                width: 24px;
                height: 24px;
                margin-right: 0.5rem;
            }

            > .hover-tooltip {
                color: #000;
                position: absolute;
                font-size: 1rem;
                bottom: 0;
                padding-bottom: 32px;
                white-space: nowrap;
                opacity: 0;
                pointer-events: none;
                justify-content: center;
                align-items: center;
                width: 100%;
                display: none;
                z-index: 100;
                font-weight: normal;

                > .text {
                    background: #fff;
                    border-radius: 5px;
                    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
                    padding: 4px 8px;
                }
            }

            &:hover {
                > .hover-tooltip {
                    display: flex;
                    opacity: 1;
                    pointer-events: all;
                }
            }

            &.is-negative {
                color: rgba(200, 100, 100, 1);
                font-weight: bold;
            }

            &.is-positive {
                color: rgba(100, 200, 100, 1);
                font-weight: bold;
            }
        }
    }

    > .invoiceFiles {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 1rem 1rem 0;

        > .titles {
            font-weight: bold;
            font-size: 0.8rem;
        }

        > .file,
        > .titles {
            display: flex;
            margin-bottom: 1rem;

            > .fileName {
                margin-right: 2rem;
                width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            > .icon {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-right: 2rem;
                position: relative;
                width: 8vw;
                white-space: nowrap;

                > .text {
                    font-size: 0.8rem;
                    font-weight: bold;
                    padding-right: 1rem;
                }

                > svg {
                    width: 24px;
                    height: 24px;
                    margin-right: 0.5rem;
                }

                > .hover-tooltip {
                    color: #000;
                    position: absolute;
                    font-size: 1rem;
                    bottom: 0;
                    padding-bottom: 32px;
                    white-space: nowrap;
                    opacity: 0;
                    pointer-events: none;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    display: none;
                    z-index: 100;
                    font-weight: normal;

                    > .text {
                        background: #fff;
                        border-radius: 5px;
                        box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
                        padding: 4px 8px;
                    }
                }

                &:hover {
                    > .hover-tooltip {
                        display: flex;
                        opacity: 1;
                        pointer-events: all;
                    }
                }

                &.is-negative {
                    color: rgba(200, 100, 100, 1);
                    font-weight: bold;
                }

                &.is-positive {
                    color: rgba(100, 200, 100, 1);
                    font-weight: bold;
                }
            }
        }
    }

    > .missingOrders {
        width: 100%;

        > table {
            width: 100%;
            th {
                padding: 1rem 1rem 0;
            }
            td {
                padding: 0 1rem;

                &:last-child {
                    width: 260px;
                }
            }

            th:last-child {
                text-align: right;
            }
        }
    }

    > .customers {
        width: 100%;

        > .batch {
            display: flex;
            align-items: center;
            padding: 1rem;
            gap: 1rem;

            > .progress {
                display: flex;
                gap: 1rem;
                align-items: center;
            }
        }

        > .customer {
            width: 100%;
            background: #fff;

            + .customer {
                border-top: 1px solid #aaa;
            }

            > .header {
                width: 100%;
                display: flex;
                align-items: center;
                padding: 1rem;

                > .title {
                    font-size: 2rem;
                    font-weight: bold;
                }

                > .information {
                    margin-right: auto;
                    display: flex;

                    > .warnings,
                    > .errors,
                    > .insurances,
                    > .done {
                        padding-left: 8px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        z-index: 10;
                        color: #e27300;
                        padding-left: 1rem;

                        > .text {
                            position: absolute;
                            opacity: 0;
                            display: flex;
                            justify-content: center;
                            text-align: center;
                            background: #fff;
                            padding: 0.4em;
                            border-radius: 0.4em;
                            box-shadow: 0px 1px 8px 5px rgba(0, 0, 0, 0.1);
                            bottom: 100%;
                            color: #555;
                            font-weight: normal;
                            transition: opacity 0.3s ease;
                            pointer-events: none;
                            width: 100vw;
                            max-width: 20vw;
                        }

                        > .icon {
                            width: 12px;
                            height: 12px;
                            padding: 4px;
                            box-sizing: content-box;
                        }

                        &:hover {
                            > .text {
                                opacity: 1;
                                pointer-events: all;
                            }
                        }
                    }
                    > .errors {
                        color: #ff0000;
                    }
                    > .insurances,
                    > .done {
                        color: #009900;
                    }
                }

                > .icon {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 2rem;
                    position: relative;

                    > svg {
                        width: 24px;
                        height: 24px;
                        margin-right: 0.5rem;
                    }

                    > .hover-tooltip {
                        color: #000;
                        position: absolute;
                        font-size: 1rem;
                        bottom: 0;
                        padding-bottom: 32px;
                        white-space: nowrap;
                        opacity: 0;
                        pointer-events: none;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        display: none;
                        z-index: 100;

                        > .text {
                            background: #fff;
                            border-radius: 5px;
                            box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
                            padding: 4px 8px;
                        }
                    }

                    &:hover {
                        > .hover-tooltip {
                            display: flex;
                            opacity: 1;
                            pointer-events: all;
                        }
                    }

                    &.is-negative {
                        color: rgba(200, 100, 100, 1);
                        font-weight: bold;
                    }

                    &.is-positive {
                        color: rgba(100, 200, 100, 1);
                        font-weight: bold;
                    }
                }

                > .createInvoice {
                    display: flex;
                    align-items: center;
                    padding-right: 2rem;
                }

                > .toggle {
                    width: 24px;
                    height: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &.is-expanded {
                        transform: rotate3d(0, 0, 1, 180deg);
                    }

                    > svg {
                        width: 100%;
                        height: 100%;
                        transform: rotate3d(0, 0, 1, 90deg);
                    }
                }
            }

            > .pagination {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 2rem;

                > .previous,
                > .next {
                    padding: 0 1rem;
                    cursor: pointer;
                }
            }

            > .rows {
                display: grid;
                grid-template: 1fr / 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
                padding-bottom: 1rem;

                &.is-expanded {
                    height: auto;
                }

                &.is-disabled {
                    pointer-events: none;
                    filter: grayscale(1);
                }

                > .title {
                    padding: 1rem;
                    font-weight: bold;

                    > .icon {
                        width: 16px;
                        height: 16px;
                        cursor: pointer;

                        > svg {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                > .cell {
                    padding: 0.2rem 1rem;

                    &.center {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    &.checkbox {
                        display: flex;
                        align-items: center;
                    }

                    &.bold {
                        font-weight: bold;
                    }

                    &.align-right {
                        text-align: right;
                    }

                    &.is-negative {
                        color: rgba(200, 100, 100, 1);
                        font-weight: bold;
                    }

                    &.is-positive {
                        color: rgba(100, 200, 100, 1);
                        font-weight: bold;
                    }

                    &.info {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    &.icons {
                        display: flex;
                        gap: 0.5rem;
                    }

                    > .icon {
                        width: 16px;
                        height: 16px;
                        cursor: pointer;

                        > svg {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    > .error,
                    > .warning,
                    > .insurance,
                    > .done {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        z-index: 10;
                        color: #e27300;

                        > .text {
                            position: absolute;
                            opacity: 0;
                            text-align: center;
                            background: #fff;
                            padding: 0.4em;
                            border-radius: 0.4em;
                            box-shadow: 0px 1px 8px 5px rgba(0, 0, 0, 0.1);
                            bottom: 100%;
                            color: #555;
                            font-weight: normal;
                            transition: opacity 0.3s ease;
                            pointer-events: none;
                            width: 100vw;
                            max-width: 20vw;
                        }

                        > .icon {
                            width: 12px;
                            height: 12px;
                            padding: 4px;
                            box-sizing: content-box;
                        }

                        &:hover {
                            > .text {
                                opacity: 1;
                                pointer-events: all;
                            }
                        }
                    }

                    > .error {
                        color: #ff0000;
                    }
                    > .insurance,
                    > .done {
                        color: #009900;
                    }
                }

                > .cellDivider {
                    grid-column: 1 / 12;
                    height: 1rem;
                    width: 100%;
                    margin-bottom: 1rem;
                    border-bottom: 1px solid #aaa;
                }
            }
        }
    }
`;

function View(props) {
    const context = useContext(Context);
    const [dndMessage, setDndMessage] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [missingOrders, setMissingOrders] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [totalSummary, setTotalSummary] = useState(null);
    const [invoiceFileSummary, setInvoiceFileSummary] = useState({});
    const [loading, setLoading] = useState(false);
    const isBatchInvoicingRef = useRef(false);
    const [batchInvoiceCustomersSuccess, setBatchInvoiceCustomersSuccess] =
        useState(0);
    const [batchInvoiceCustomersFailed, setBatchInvoiceCustomersFailed] =
        useState(0);
    const [batchInvoiceCustomersSkipped, setBatchInvoiceCustomersSkipped] =
        useState(0);

    const authenticated = false;

    const onDrop = useCallback((acceptedFiles) => {
        let invoiceDeferredList = [];

        setLoading(true);

        acceptedFiles.forEach((file) => {
            let def = new deferred();
            invoiceDeferredList.push(def.promise);
            const file2 = file;
            if (
                [".csv", ".txt", ".xml"].indexOf(
                    file.name.substr(-4).toLowerCase(),
                ) >= 0
            ) {
                setDndMessage(null);

                const reader = new FileReader();

                reader.onabort = () =>
                    console.error("file reading was aborted");
                reader.onerror = () => console.error("file reading has failed");
                reader.onload = () => {
                    let fileContent = reader.result.toString();
                    if (fileContent.startsWith("<?xml")) {
                        let jsonResponse = JSON.parse(
                            convert.xml2json(fileContent, {
                                compact: true,
                            }),
                        );

                        if (jsonResponse.Download?.Invoice_Download) {
                            const items = FedexParser.parse({
                                data: jsonResponse,
                                fileName: file.name,
                            });
                            def.resolve(items);
                        }
                    } else if (fileContent.startsWith("Debet/Kredit-kod;")) {
                        // DHL CSV file

                        file.arrayBuffer().then((buffer) => {
                            const items = DHLParser.parse({
                                data: iconv.decode(
                                    Buffer.from(buffer),
                                    "ISO-8859-1",
                                ),
                                fileName: file.name,
                            });

                            def.resolve(items);
                        });
                    } else if (fileContent.startsWith("Account Number")) {
                        // TNT CSV file
                        const items = TNTParser.parse({
                            data: fileContent,
                            fileName: file.name,
                        });
                        def.resolve(items);
                    } else if (fileContent.startsWith("2.1,")) {
                        // UPS CSV file
                        const items = UPSParser.parse({
                            data: fileContent,
                            fileName: file.name,
                        });
                        def.resolve(items);
                    } else if (fileContent.startsWith("Date;AWB nr.;")) {
                        // DHL Express CSV file ASCII encoded so try again.
                        const lemanReader = new FileReader();
                        lemanReader.onabort = () =>
                            console.error("file reading was aborted");
                        lemanReader.onerror = () =>
                            console.error("file reading has failed");
                        lemanReader.onload = () => {
                            let lemanContent = lemanReader.result.toString();
                            const items = LemanParser.parse({
                                data: lemanContent,
                                fileName: file.name,
                            });
                            def.resolve(items);
                        };

                        lemanReader.readAsText(file2, "ASCII");
                    } else if (fileContent.startsWith('"Line Type')) {
                        // Freja CSV file
                        const items = FrejaParser.parse({
                            data: fileContent,
                            fileName: file.name,
                        });
                        def.resolve(items);
                    }
                };
                reader.readAsText(file);
            } else if (
                [".xlsx"].indexOf(file.name.substr(-5).toLowerCase()) >= 0
            ) {
                setDndMessage(null);
                const reader = new FileReader();
                reader.onabort = () =>
                    console.error("file reading was aborted");
                reader.onerror = () => console.error("file reading has failed");
                reader.onload = () => {
                    var workbook = XLSX.read(reader.result, {
                        type: "binary",
                    });

                    if (
                        Object.values(
                            workbook.Sheets[workbook.SheetNames[0]],
                        ).some(
                            /*  PostNord invoice:
                                This should be unique enough to correctly match that the invoice is from PostNord,
                                without interfering with other carriers invoices. */
                            (cell) =>
                                typeof cell.v === "string" &&
                                cell.v.includes(
                                    "Customer name during consignee freight",
                                ),
                        )
                    ) {
                        const items = PostNordParser.parse({
                            workbook,
                            fileName: file.name,
                        });
                        def.resolve(items);
                    } else if (
                        workbook.SheetNames.length > 0 &&
                        workbook.Sheets[workbook.SheetNames[0]] &&
                        workbook.Sheets[workbook.SheetNames[0]]["C1"] &&
                        workbook.Sheets[workbook.SheetNames[0]]["C1"]["v"] ===
                            "Fakturarapport"
                    ) {
                        // This is probably a DSV invoice
                        const items = DSVParser.parse({
                            workbook,
                            fileName: file.name,
                        });
                        def.resolve(items);
                    } else if (
                        workbook.SheetNames.length > 0 &&
                        workbook.Sheets[workbook.SheetNames[0]] &&
                        workbook.Sheets[workbook.SheetNames[0]]["J12"] &&
                        workbook.Sheets[workbook.SheetNames[0]]["J12"]["v"] ===
                            "Mottaget av Bring datum och tid"
                    ) {
                        const items = BringParser.parse({
                            workbook,
                            fileName: file.name,
                        });
                        def.resolve(items);
                    } else {
                        // Custom file parser
                        const rows = [].concat
                            .apply(
                                [],
                                workbook.SheetNames.map(function (sheetName) {
                                    if (
                                        workbook.Sheets[sheetName].A1.v !==
                                        "Transportör"
                                    ) {
                                        return null;
                                    }
                                    if (
                                        workbook.Sheets[sheetName].B1.v !==
                                        "Trackingnummer"
                                    ) {
                                        return null;
                                    }
                                    if (
                                        workbook.Sheets[sheetName].C1.v !==
                                        "Externt fakturanummer"
                                    ) {
                                        return null;
                                    }
                                    return XLSX.utils.sheet_to_row_object_array(
                                        workbook.Sheets[sheetName],
                                    );
                                }),
                            )
                            .filter((c) => c);
                        if (rows && rows.length) {
                            const items = CustomParser.parse({
                                data: rows,
                                fileName: file.name,
                            });
                            def.resolve(items);
                        } else {
                            def.resolve([]);
                        }
                    }
                };
                reader.readAsBinaryString(file);
            } else {
                setDndMessage("Endast CSV- och XML-filer går att använda.");
            }
        });

        deferred.apply(null, invoiceDeferredList).done(async (orders) => {
            try {
                const response = await Api.getInvoiceDraft({
                    orders: orders.flat(),
                });

                setInvoiceFileSummary((summary) => {
                    return {
                        ...summary,
                        ...response.invoiceFiles,
                    };
                });
                mergeCustomers(response.customers);
                setMissingOrders((missingOrders) => {
                    return missingOrders
                        .filter((order) => {
                            return !response.missingOrders.find((o) => {
                                return (
                                    o.trackingNumber === order.trackingNumber
                                );
                            });
                        })
                        .concat(response.missingOrders);
                });
            } catch (error) {
                toast.error(
                    "Något gick fel vid hantering av faktura. Var god försök igen.",
                );
            } finally {
                setLoading(false);
            }
        });
        327;
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    function mergeCustomers(customers) {
        setCustomers((oldCustomerList) => {
            // TODO: Why does this not work?
            let newCustomersList = [];

            for (const customer of customers) {
                let existingCustomer = oldCustomerList.find((c) => {
                    return c.id === customer.id;
                });

                if (existingCustomer) {
                    let ordersList = [].concat(existingCustomer.orders);

                    for (const order of customer.orders) {
                        const existingOrder = ordersList.find(
                            (o) => o.id === order.id,
                        );
                        if (
                            !existingOrder ||
                            existingOrder.fileName !== order.fileName
                        ) {
                            ordersList.push(order);
                        }
                    }

                    oldCustomerList = oldCustomerList.map((c) => {
                        if (c.id === existingCustomer.id) {
                            return {
                                ...c,
                                orders: ordersList,
                            };
                        } else {
                            return c;
                        }
                    });
                } else {
                    newCustomersList.push(customer);
                }
            }

            for (const oldCustomer of oldCustomerList) {
                if (!newCustomersList.find((c) => c.id === oldCustomer.id)) {
                    newCustomersList.push(oldCustomer);
                }
            }

            return newCustomersList.sort(customerListSort);
        });
    }

    useEffect(() => {
        if (
            context.user.administrator ||
            (context.user.brand && context.user.brand.id)
        ) {
            // loadInvoices();
        } else {
            props.history.replace("/admin");
        }

        // Api.getFortnoxArticles
    }, []);

    useEffect(() => {
        if (missingOrders.length > 0 && customerList.length === 0) {
            loadCustomerList();
        }
    }, [missingOrders]);

    useEffect(() => {
        if (customers?.length) {
            let invoiceFiles = {};
            const {
                totalShipmentCost,
                totalPartnerCost,
                totalCostVat,
                totalCostNoVat,
                totalCustomerPrice,
                result,
                orderCount,
            } = customers.reduce(
                (acc, customer) => {
                    const {
                        customerTotalShipmentCost,
                        customerTotalPartnerCost,
                        customerTotalCustomerPrice,
                        customerTotalCostVat,
                        customerTotalCostNoVat,
                        customerResult,
                        customerOrderCount,
                    } = customer.orders.reduce(
                        (customerAcc, order) => {
                            const orderCustomerPrice = order.rows.reduce(
                                (price, row) => {
                                    if (row.cost) {
                                        price += row.cost;
                                    }
                                    return price;
                                },
                                order.customerTransportPrice,
                            );
                            if (!invoiceFiles[order.fileName]) {
                                invoiceFiles[order.fileName] = {
                                    shipmentCost: 0,
                                    totalCostVat: 0,
                                    totalCostNoVat: 0,
                                    partnerCost: 0,
                                    customerPrice: 0,
                                    result: 0,
                                    hitCount: 0,
                                };
                            }

                            invoiceFiles[order.fileName].shipmentCost +=
                                order.totalShipmentCost;
                            invoiceFiles[order.fileName].totalCostVat +=
                                order.vat
                                    ? order.totalShipmentCost +
                                      order.partnerCost
                                    : 0;
                            invoiceFiles[order.fileName].totalCostNoVat +=
                                !order.vat
                                    ? order.totalShipmentCost +
                                      order.partnerCost
                                    : 0;
                            invoiceFiles[order.fileName].partnerCost +=
                                order.partnerCost;
                            invoiceFiles[order.fileName].customerPrice +=
                                orderCustomerPrice;
                            invoiceFiles[order.fileName].result +=
                                orderCustomerPrice -
                                order.totalShipmentCost -
                                order.partnerCost;
                            invoiceFiles[order.fileName].hitCount++;

                            return {
                                customerTotalShipmentCost:
                                    customerAcc.customerTotalShipmentCost +
                                    order.totalShipmentCost,
                                customerTotalPartnerCost:
                                    customerAcc.customerTotalPartnerCost +
                                    order.partnerCost,
                                customerTotalCostVat:
                                    customerAcc.customerTotalCostVat +
                                    (order.vat
                                        ? order.totalShipmentCost +
                                          order.partnerCost
                                        : 0),
                                customerTotalCostNoVat:
                                    customerAcc.customerTotalCostNoVat +
                                    (!order.vat
                                        ? order.totalShipmentCost +
                                          order.partnerCost
                                        : 0),
                                customerTotalCustomerPrice:
                                    customerAcc.customerTotalCustomerPrice +
                                    orderCustomerPrice,
                                customerResult:
                                    customerAcc.customerResult +
                                    orderCustomerPrice -
                                    order.totalShipmentCost -
                                    order.partnerCost,
                                customerOrderCount:
                                    customerAcc.customerOrderCount + 1,
                            };
                        },
                        {
                            customerTotalShipmentCost: 0,
                            customerTotalCostVat: 0,
                            customerTotalCostNoVat: 0,
                            customerTotalPartnerCost: 0,
                            customerTotalCustomerPrice: 0,
                            customerResult: 0,
                            customerOrderCount: 0,
                        },
                    );

                    return {
                        totalShipmentCost:
                            acc.totalShipmentCost + customerTotalShipmentCost,
                        totalCostVat: acc.totalCostVat + customerTotalCostVat,
                        totalCostNoVat:
                            acc.totalCostNoVat + customerTotalCostNoVat,
                        totalPartnerCost:
                            acc.totalPartnerCost + customerTotalPartnerCost,
                        totalCustomerPrice:
                            acc.totalCustomerPrice + customerTotalCustomerPrice,
                        result: acc.result + customerResult,
                        orderCount: acc.orderCount + customerOrderCount,
                    };
                },
                {
                    totalShipmentCost: 0,
                    totalCostVat: 0,
                    totalCostNoVat: 0,
                    totalPartnerCost: 0,
                    totalCustomerPrice: 0,
                    result: 0,
                    orderCount: 0,
                },
            );

            setInvoiceFileSummary((oldFiles) => {
                Object.keys(invoiceFiles).forEach((fileName) => {
                    if (oldFiles[fileName]) {
                        invoiceFiles[fileName].orderCount =
                            oldFiles[fileName].orderCount;
                    }
                });

                const summary = {
                    ...oldFiles,
                    ...invoiceFiles,
                };

                setTotalSummary({
                    shipmentCost: totalShipmentCost,
                    totalCostVat: totalCostVat,
                    totalCostNoVat: totalCostNoVat,
                    partnerCost: totalPartnerCost,
                    customerPrice: totalCustomerPrice,
                    result,
                    orderCount: Object.keys(summary).reduce((acc, fileName) => {
                        return acc + summary[fileName].orderCount;
                    }, 0),
                    hitCount: Object.keys(summary).reduce((acc, fileName) => {
                        return acc + summary[fileName].hitCount;
                    }, 0),
                });

                return summary;
            });
        }
    }, [customers]);

    async function loadCustomerList() {
        setCustomerList(await Api.getCustomers());
    }

    function updateCustomer(updatedCustomer) {
        setCustomers((customers) => {
            return customers
                .map((customer) => {
                    if (customer.id === updatedCustomer.id) {
                        return updatedCustomer;
                    } else {
                        return customer;
                    }
                })
                .filter((customer) => {
                    return customer.orders.length > 0;
                });
        });
    }

    async function pairOrder({ order, customerId }) {
        if (customerId) {
            const response = await Api.createOrderFromInvoice({
                customerId,
                order,
            });
            mergeCustomers([response.customer]);
            setMissingOrders((oldList) => {
                return oldList.filter(
                    (o) => o.trackingNumber !== order.trackingNumber,
                );
            });
        }
    }

    function moveOrder({ order, customer }) {
        setCustomers((customers) => {
            if (
                customers.find((c) => {
                    return c.id === customer.id;
                })
            ) {
                return customers.map((c) => {
                    if (c.id === customer.id) {
                        return {
                            ...c,
                            orders: [].concat(c.orders).concat(order),
                        };
                    } else {
                        return c;
                    }
                });
            } else {
                return [].concat(customers).concat({
                    id: customer.id,
                    name: customer.name,
                    orders: [order],
                });
            }
        });
    }

    function sortCustomers(customerA, customerB) {
        if (customerA.name?.toLowerCase() < customerB.name?.toLowerCase()) {
            return -1;
        }
        if (customerA.name?.toLowerCase() > customerB.name?.toLowerCase()) {
            return 1;
        }
        return 0;
    }

    return (
        <FortnoxAuthenticator>
            <Container>
                <div className="dropInvoices" {...getRootProps()}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                        <p>Släpp filerna här</p>
                    ) : dndMessage ? (
                        dndMessage
                    ) : (
                        <p>
                            {loading
                                ? "Laddar in fakturor..."
                                : "Fakturaunderlag"}
                        </p>
                    )}
                </div>
                {invoiceFileSummary && (
                    <div className="invoiceFiles">
                        <div className="titles">
                            <div className="fileName">Filnamn</div>
                            <div className="icon">Antalet försändelser</div>
                            <div className="icon">Total kostnad</div>
                            <div className="icon">Partnerkostnad</div>
                            <div className="icon">Tot momspl</div>
                            <div className="icon">Tot ej momspl</div>
                            <div className="icon">Kundens pris</div>
                            <div className="icon">Resultat</div>
                        </div>
                        {Object.entries(invoiceFileSummary).map(
                            ([fileName, summary]) => {
                                return (
                                    <div className="file" key={fileName}>
                                        <div
                                            className="fileName"
                                            title={fileName}
                                        >
                                            {fileName}
                                        </div>
                                        <div className="icon">
                                            <div className="hover-tooltip">
                                                <div className="text">
                                                    Antalet försändelser
                                                </div>
                                            </div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24 17v-21h21v2h-19v19h-2z"
                                                />
                                            </svg>
                                            {summary.hitCount} /{" "}
                                            {summary.orderCount}
                                        </div>
                                        <div className="icon">
                                            <div className="hover-tooltip">
                                                <div className="text">
                                                    Total kostnad
                                                </div>
                                            </div>
                                            <svg
                                                width="24"
                                                height="24"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                            >
                                                <path d="M5 11v1h8v-7h-10v-1c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v2h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035v4.48c0 1.089-.743 2-2 2h-1c0 1.656-1.344 3-3 3s-3-1.344-3-3h-4c0 1.656-1.344 3-3 3s-3-1.344-3-3h-1c-.552 0-1-.448-1-1v-6h-2v-2h7v2h-3zm3 5.8c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm10 0c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm-3-2.8h-10v2h.765c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h5.53c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h1.765v-4.575l-1.711-2.929c-.179-.307-.508-.496-.863-.496h-4.426v6zm1-5v3h5l-1.427-2.496c-.178-.312-.509-.504-.868-.504h-2.705zm-16-3h8v2h-8v-2z" />
                                            </svg>
                                            {priceParser(
                                                Math.round(
                                                    summary.shipmentCost,
                                                ),
                                            )}
                                        </div>
                                        <div className="icon">
                                            <div className="hover-tooltip">
                                                <div className="text">
                                                    Partnerkostnad
                                                </div>
                                            </div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M0 12.562l1.932-7.562 3.526.891-1.974 7.562-3.484-.891zm18.415.902c.125.287.187.598.155.91-.079.829-.698 1.448-1.457 1.602-.254.533-.733.887-1.285 1.002-.244.512-.722.89-1.296 1.01-.325.668-.97 1.012-1.674 1.012-.516 0-1.004-.183-1.356-.538-.928.404-1.902-.048-2.232-.863-.596-.068-1.107-.452-1.332-.997-.599-.071-1.114-.458-1.34-1.003-1.188-.138-1.848-1.44-1.198-2.495-.233-.058-.494-.104-.751-.152l.383-1.464c.524.1 1.01.219 1.453.358.913-.655 2.151-.295 2.549.679.608.069 1.116.464 1.334 1 .598.068 1.111.451 1.335.998.738.082 1.36.653 1.449 1.434l.002.225.45.402c.252.291.68.324.96.106.286-.223.324-.624.075-.909l-1.457-1.279c-.157-.139.052-.38.213-.241l1.491 1.308c.257.294.692.332.969.114.285-.22.316-.631.068-.916l-1.896-1.628c-.162-.135.048-.38.208-.242l1.944 1.669c.248.282.678.335.967.114.283-.22.349-.606-.002-.995-1.24-1.112-2.671-2.405-4.143-3.796-.355.488-2.176 1.502-3.279 1.502s-1.779-.675-1.96-1.343c-.157-.582.051-1.139.532-1.42.535-.313 1.055-.761 1.562-1.268-.789-.586-1.203-.398-2.067.013-.503.238-1.1.521-1.854.647l.437-1.67c1.327-.488 2.549-1.608 4.505-.083l.491-.552c.395-.447.911-.715 1.503-.715.436 0 .91.161 1.408.417 1.518.793 2.293 1.256 3.443 1.294l.394 1.508h-.008c-1.797.033-2.676-.508-4.516-1.47-.513-.263-.859-.318-1.1-.044-.984 1.12-2.031 2.309-3.192 3.063.573.458 2.019-.458 2.592-.92.25-.201.638-.468 1.128-.468.553 0 .955.331 1.244.619.68.68 2.57 2.389 3.407 3.142.434-.242.868-.435 1.311-.605l.383 1.467c-.319.134-.633.286-.95.461zm-11.037.875l.609-.747c.25-.3.215-.722-.08-.944-.296-.223-.737-.158-.986.14l-.61.749c-.251.298-.214.721.08.942s.737.159.987-.14zm1.328 1.006l.617-.755c.248-.297.213-.722-.082-.943-.294-.221-.734-.159-.984.142l-.616.754c-.251.3-.21.712.086.936.297.222.729.167.979-.134zm1.343.992l.608-.747c.251-.299.215-.721-.08-.944-.296-.222-.735-.157-.986.142l-.609.745c-.251.3-.213.724.082.945.293.221.734.16.985-.141zm1.865-.691c-.294-.224-.735-.159-.987.139l-.612.751c-.249.299-.213.722.082.943.295.221.735.16.986-.142l.61-.75c.253-.297.217-.72-.079-.941zm1.427 1.134l-.24-.212c-.063.239-.173.464-.332.65l-.358.441c.133.106.288.176.448.176.149 0 .295-.046.415-.138.284-.223.317-.632.067-.917zm5.201-10.889l1.974 7.562 3.484-.891-1.932-7.562-3.526.891z"
                                                />
                                            </svg>
                                            {priceParser(
                                                Math.round(summary.partnerCost),
                                            )}
                                        </div>
                                        <div className="icon">
                                            <div className="hover-tooltip">
                                                <div className="text">
                                                    Totalt momspliktigt
                                                </div>
                                            </div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M10.81 11.885h-1.098l.066-.739h1.069l-.037.739zm.613 1.099h1.14l-.007-.739h-1.111l-.022.739zm.085-2.971l-.021.739h1.054l-.007-.739h-1.026zm-1.894 2.971h1.14l.038-.739h-1.112l-.066.739zm1.291-2.971h-1.026l-.066.739h1.054l.038-.739zm6.308 0l.137.739h1.054l-.165-.739h-1.026zm-4.115 0l.023.739h1.054l-.051-.739h-1.026zm1.155 1.872l-.051-.739h-1.069l.022.739h1.098zm3.309-4.885h-7.406l-.204 2h8.058l-.448-2zm-6.107 4.885h1.097l-.007-.739h-1.069l-.021.739zm2.874 1.099l-.051-.739h-1.111l.023.739h1.139zm-5.888-2.971h-1.025l-.134.739h1.054l.105-.739zm10.215 1.872l-.165-.739h-1.069l.136.739h1.098zm-12.074-.739h-1.069l-.179.739h1.097l.151-.739zm.231-1.133h-1.026l-.179.739h1.054l.151-.739zm17.187 4.987v7h-24v-7h24zm-2 2h-20v3h20v-3zm-9 1h-2v1h2v-1zm-7.932-5.016h1.14l.15-.739h-1.111l-.179.739zm11.702-2.233l-.121-.739h-1.026l.093.739h1.054zm.185 1.134l-.121-.739h-1.069l.093.739h1.097zm1.946 1.099l-.165-.739h-2.833l.093.739h2.905zm-10.622-1.838h-1.069l-.134.739h1.098l.105-.739zm-1.402 1.838h1.139l.105-.739h-1.11l-.134.739zm-5.595.016l2.621-9h1.921c.112-.622.322-1.371.668-2h3.427c-.26.57-.499 1.259-.627 2h10.805l2.592 9h-2.221l-1.804-7h-9.42c.071.836.178 1.511-.107 2h-3.456c.292-.431.166-1.111.086-2h-.481l-1.739 7h-2.265zm5.101-6.631h2.298c-.157-1.076-.092-2.782.404-3.786h-2.249c-.553 1.006-.624 2.64-.453 3.786z"
                                                />
                                            </svg>
                                            {priceParser(
                                                Math.round(
                                                    summary.totalCostVat,
                                                ),
                                            )}
                                        </div>
                                        <div className="icon">
                                            <div className="hover-tooltip">
                                                <div className="text">
                                                    Totalt ej momspliktigt
                                                </div>
                                            </div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M10.81 11.885h-1.098l.066-.739h1.069l-.037.739zm.613 1.099h1.14l-.007-.739h-1.111l-.022.739zm.085-2.971l-.021.739h1.054l-.007-.739h-1.026zm-1.894 2.971h1.14l.038-.739h-1.112l-.066.739zm1.291-2.971h-1.026l-.066.739h1.054l.038-.739zm6.308 0l.137.739h1.054l-.165-.739h-1.026zm-4.115 0l.023.739h1.054l-.051-.739h-1.026zm1.155 1.872l-.051-.739h-1.069l.022.739h1.098zm3.309-4.885h-7.406l-.204 2h8.058l-.448-2zm-6.107 4.885h1.097l-.007-.739h-1.069l-.021.739zm2.874 1.099l-.051-.739h-1.111l.023.739h1.139zm-5.888-2.971h-1.025l-.134.739h1.054l.105-.739zm10.215 1.872l-.165-.739h-1.069l.136.739h1.098zm-12.074-.739h-1.069l-.179.739h1.097l.151-.739zm.231-1.133h-1.026l-.179.739h1.054l.151-.739zm17.187 4.987v7h-24v-7h24zm-2 2h-20v3h20v-3zm-9 1h-2v1h2v-1zm-7.932-5.016h1.14l.15-.739h-1.111l-.179.739zm11.702-2.233l-.121-.739h-1.026l.093.739h1.054zm.185 1.134l-.121-.739h-1.069l.093.739h1.097zm1.946 1.099l-.165-.739h-2.833l.093.739h2.905zm-10.622-1.838h-1.069l-.134.739h1.098l.105-.739zm-1.402 1.838h1.139l.105-.739h-1.11l-.134.739zm-5.595.016l2.621-9h1.921c.112-.622.322-1.371.668-2h3.427c-.26.57-.499 1.259-.627 2h10.805l2.592 9h-2.221l-1.804-7h-9.42c.071.836.178 1.511-.107 2h-3.456c.292-.431.166-1.111.086-2h-.481l-1.739 7h-2.265zm5.101-6.631h2.298c-.157-1.076-.092-2.782.404-3.786h-2.249c-.553 1.006-.624 2.64-.453 3.786z"
                                                />
                                            </svg>
                                            {priceParser(
                                                Math.round(
                                                    summary.totalCostNoVat,
                                                ),
                                            )}
                                        </div>
                                        <div className="icon">
                                            <div className="hover-tooltip">
                                                <div className="text">
                                                    Kundens pris
                                                </div>
                                            </div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M10.81 11.885h-1.098l.066-.739h1.069l-.037.739zm.613 1.099h1.14l-.007-.739h-1.111l-.022.739zm.085-2.971l-.021.739h1.054l-.007-.739h-1.026zm-1.894 2.971h1.14l.038-.739h-1.112l-.066.739zm1.291-2.971h-1.026l-.066.739h1.054l.038-.739zm6.308 0l.137.739h1.054l-.165-.739h-1.026zm-4.115 0l.023.739h1.054l-.051-.739h-1.026zm1.155 1.872l-.051-.739h-1.069l.022.739h1.098zm3.309-4.885h-7.406l-.204 2h8.058l-.448-2zm-6.107 4.885h1.097l-.007-.739h-1.069l-.021.739zm2.874 1.099l-.051-.739h-1.111l.023.739h1.139zm-5.888-2.971h-1.025l-.134.739h1.054l.105-.739zm10.215 1.872l-.165-.739h-1.069l.136.739h1.098zm-12.074-.739h-1.069l-.179.739h1.097l.151-.739zm.231-1.133h-1.026l-.179.739h1.054l.151-.739zm17.187 4.987v7h-24v-7h24zm-2 2h-20v3h20v-3zm-9 1h-2v1h2v-1zm-7.932-5.016h1.14l.15-.739h-1.111l-.179.739zm11.702-2.233l-.121-.739h-1.026l.093.739h1.054zm.185 1.134l-.121-.739h-1.069l.093.739h1.097zm1.946 1.099l-.165-.739h-2.833l.093.739h2.905zm-10.622-1.838h-1.069l-.134.739h1.098l.105-.739zm-1.402 1.838h1.139l.105-.739h-1.11l-.134.739zm-5.595.016l2.621-9h1.921c.112-.622.322-1.371.668-2h3.427c-.26.57-.499 1.259-.627 2h10.805l2.592 9h-2.221l-1.804-7h-9.42c.071.836.178 1.511-.107 2h-3.456c.292-.431.166-1.111.086-2h-.481l-1.739 7h-2.265zm5.101-6.631h2.298c-.157-1.076-.092-2.782.404-3.786h-2.249c-.553 1.006-.624 2.64-.453 3.786z"
                                                />
                                            </svg>
                                            {priceParser(
                                                Math.round(
                                                    summary.customerPrice,
                                                ),
                                            )}
                                        </div>
                                        <div
                                            className={`icon ${
                                                summary.result > 0
                                                    ? "is-positive"
                                                    : "is-negative"
                                            }`}
                                        >
                                            <div className="hover-tooltip">
                                                <div className="text">
                                                    Resultat
                                                </div>
                                            </div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4 14.083c0-2.145-2.232-2.742-3.943-3.546-1.039-.54-.908-1.829.581-1.916.826-.05 1.675.195 2.443.465l.362-1.647c-.907-.276-1.719-.402-2.443-.421v-1.018h-1v1.067c-1.945.267-2.984 1.487-2.984 2.85 0 2.438 2.847 2.81 3.778 3.243 1.27.568 1.035 1.75-.114 2.011-.997.226-2.269-.168-3.225-.54l-.455 1.644c.894.462 1.965.708 3 .727v.998h1v-1.053c1.657-.232 3.002-1.146 3-2.864z"
                                                />
                                            </svg>
                                            {priceParser(
                                                Math.round(summary.result),
                                            )}
                                        </div>
                                    </div>
                                );
                            },
                        )}
                    </div>
                )}
                {totalSummary && (
                    <div className="summary">
                        <div className="title">Totalt</div>
                        <div className="icon">
                            <div className="hover-tooltip">
                                <div className="text">Antalet försändelser</div>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24 17v-21h21v2h-19v19h-2z"
                                />
                            </svg>
                            {totalSummary.hitCount} / {totalSummary.orderCount}
                        </div>
                        <div className="icon">
                            <div className="hover-tooltip">
                                <div className="text">Total kostnad</div>
                            </div>
                            <svg
                                width="24"
                                height="24"
                                xmlns="http://www.w3.org/2000/svg"
                                fillRule="evenodd"
                                clipRule="evenodd"
                            >
                                <path d="M5 11v1h8v-7h-10v-1c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v2h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035v4.48c0 1.089-.743 2-2 2h-1c0 1.656-1.344 3-3 3s-3-1.344-3-3h-4c0 1.656-1.344 3-3 3s-3-1.344-3-3h-1c-.552 0-1-.448-1-1v-6h-2v-2h7v2h-3zm3 5.8c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm10 0c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm-3-2.8h-10v2h.765c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h5.53c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h1.765v-4.575l-1.711-2.929c-.179-.307-.508-.496-.863-.496h-4.426v6zm1-5v3h5l-1.427-2.496c-.178-.312-.509-.504-.868-.504h-2.705zm-16-3h8v2h-8v-2z" />
                            </svg>
                            {priceParser(Math.round(totalSummary.shipmentCost))}
                        </div>
                        <div className="icon">
                            <div className="hover-tooltip">
                                <div className="text">Partnerkostnad</div>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M0 12.562l1.932-7.562 3.526.891-1.974 7.562-3.484-.891zm18.415.902c.125.287.187.598.155.91-.079.829-.698 1.448-1.457 1.602-.254.533-.733.887-1.285 1.002-.244.512-.722.89-1.296 1.01-.325.668-.97 1.012-1.674 1.012-.516 0-1.004-.183-1.356-.538-.928.404-1.902-.048-2.232-.863-.596-.068-1.107-.452-1.332-.997-.599-.071-1.114-.458-1.34-1.003-1.188-.138-1.848-1.44-1.198-2.495-.233-.058-.494-.104-.751-.152l.383-1.464c.524.1 1.01.219 1.453.358.913-.655 2.151-.295 2.549.679.608.069 1.116.464 1.334 1 .598.068 1.111.451 1.335.998.738.082 1.36.653 1.449 1.434l.002.225.45.402c.252.291.68.324.96.106.286-.223.324-.624.075-.909l-1.457-1.279c-.157-.139.052-.38.213-.241l1.491 1.308c.257.294.692.332.969.114.285-.22.316-.631.068-.916l-1.896-1.628c-.162-.135.048-.38.208-.242l1.944 1.669c.248.282.678.335.967.114.283-.22.349-.606-.002-.995-1.24-1.112-2.671-2.405-4.143-3.796-.355.488-2.176 1.502-3.279 1.502s-1.779-.675-1.96-1.343c-.157-.582.051-1.139.532-1.42.535-.313 1.055-.761 1.562-1.268-.789-.586-1.203-.398-2.067.013-.503.238-1.1.521-1.854.647l.437-1.67c1.327-.488 2.549-1.608 4.505-.083l.491-.552c.395-.447.911-.715 1.503-.715.436 0 .91.161 1.408.417 1.518.793 2.293 1.256 3.443 1.294l.394 1.508h-.008c-1.797.033-2.676-.508-4.516-1.47-.513-.263-.859-.318-1.1-.044-.984 1.12-2.031 2.309-3.192 3.063.573.458 2.019-.458 2.592-.92.25-.201.638-.468 1.128-.468.553 0 .955.331 1.244.619.68.68 2.57 2.389 3.407 3.142.434-.242.868-.435 1.311-.605l.383 1.467c-.319.134-.633.286-.95.461zm-11.037.875l.609-.747c.25-.3.215-.722-.08-.944-.296-.223-.737-.158-.986.14l-.61.749c-.251.298-.214.721.08.942s.737.159.987-.14zm1.328 1.006l.617-.755c.248-.297.213-.722-.082-.943-.294-.221-.734-.159-.984.142l-.616.754c-.251.3-.21.712.086.936.297.222.729.167.979-.134zm1.343.992l.608-.747c.251-.299.215-.721-.08-.944-.296-.222-.735-.157-.986.142l-.609.745c-.251.3-.213.724.082.945.293.221.734.16.985-.141zm1.865-.691c-.294-.224-.735-.159-.987.139l-.612.751c-.249.299-.213.722.082.943.295.221.735.16.986-.142l.61-.75c.253-.297.217-.72-.079-.941zm1.427 1.134l-.24-.212c-.063.239-.173.464-.332.65l-.358.441c.133.106.288.176.448.176.149 0 .295-.046.415-.138.284-.223.317-.632.067-.917zm5.201-10.889l1.974 7.562 3.484-.891-1.932-7.562-3.526.891z"
                                />
                            </svg>
                            {priceParser(Math.round(totalSummary.partnerCost))}
                        </div>
                        <div className="icon">
                            <div className="hover-tooltip">
                                <div className="text">Totalt momspliktigt</div>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M10.81 11.885h-1.098l.066-.739h1.069l-.037.739zm.613 1.099h1.14l-.007-.739h-1.111l-.022.739zm.085-2.971l-.021.739h1.054l-.007-.739h-1.026zm-1.894 2.971h1.14l.038-.739h-1.112l-.066.739zm1.291-2.971h-1.026l-.066.739h1.054l.038-.739zm6.308 0l.137.739h1.054l-.165-.739h-1.026zm-4.115 0l.023.739h1.054l-.051-.739h-1.026zm1.155 1.872l-.051-.739h-1.069l.022.739h1.098zm3.309-4.885h-7.406l-.204 2h8.058l-.448-2zm-6.107 4.885h1.097l-.007-.739h-1.069l-.021.739zm2.874 1.099l-.051-.739h-1.111l.023.739h1.139zm-5.888-2.971h-1.025l-.134.739h1.054l.105-.739zm10.215 1.872l-.165-.739h-1.069l.136.739h1.098zm-12.074-.739h-1.069l-.179.739h1.097l.151-.739zm.231-1.133h-1.026l-.179.739h1.054l.151-.739zm17.187 4.987v7h-24v-7h24zm-2 2h-20v3h20v-3zm-9 1h-2v1h2v-1zm-7.932-5.016h1.14l.15-.739h-1.111l-.179.739zm11.702-2.233l-.121-.739h-1.026l.093.739h1.054zm.185 1.134l-.121-.739h-1.069l.093.739h1.097zm1.946 1.099l-.165-.739h-2.833l.093.739h2.905zm-10.622-1.838h-1.069l-.134.739h1.098l.105-.739zm-1.402 1.838h1.139l.105-.739h-1.11l-.134.739zm-5.595.016l2.621-9h1.921c.112-.622.322-1.371.668-2h3.427c-.26.57-.499 1.259-.627 2h10.805l2.592 9h-2.221l-1.804-7h-9.42c.071.836.178 1.511-.107 2h-3.456c.292-.431.166-1.111.086-2h-.481l-1.739 7h-2.265zm5.101-6.631h2.298c-.157-1.076-.092-2.782.404-3.786h-2.249c-.553 1.006-.624 2.64-.453 3.786z"
                                />
                            </svg>
                            {priceParser(Math.round(totalSummary.totalCostVat))}
                        </div>
                        <div className="icon">
                            <div className="hover-tooltip">
                                <div className="text">
                                    Totalt ej momspliktigt
                                </div>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M10.81 11.885h-1.098l.066-.739h1.069l-.037.739zm.613 1.099h1.14l-.007-.739h-1.111l-.022.739zm.085-2.971l-.021.739h1.054l-.007-.739h-1.026zm-1.894 2.971h1.14l.038-.739h-1.112l-.066.739zm1.291-2.971h-1.026l-.066.739h1.054l.038-.739zm6.308 0l.137.739h1.054l-.165-.739h-1.026zm-4.115 0l.023.739h1.054l-.051-.739h-1.026zm1.155 1.872l-.051-.739h-1.069l.022.739h1.098zm3.309-4.885h-7.406l-.204 2h8.058l-.448-2zm-6.107 4.885h1.097l-.007-.739h-1.069l-.021.739zm2.874 1.099l-.051-.739h-1.111l.023.739h1.139zm-5.888-2.971h-1.025l-.134.739h1.054l.105-.739zm10.215 1.872l-.165-.739h-1.069l.136.739h1.098zm-12.074-.739h-1.069l-.179.739h1.097l.151-.739zm.231-1.133h-1.026l-.179.739h1.054l.151-.739zm17.187 4.987v7h-24v-7h24zm-2 2h-20v3h20v-3zm-9 1h-2v1h2v-1zm-7.932-5.016h1.14l.15-.739h-1.111l-.179.739zm11.702-2.233l-.121-.739h-1.026l.093.739h1.054zm.185 1.134l-.121-.739h-1.069l.093.739h1.097zm1.946 1.099l-.165-.739h-2.833l.093.739h2.905zm-10.622-1.838h-1.069l-.134.739h1.098l.105-.739zm-1.402 1.838h1.139l.105-.739h-1.11l-.134.739zm-5.595.016l2.621-9h1.921c.112-.622.322-1.371.668-2h3.427c-.26.57-.499 1.259-.627 2h10.805l2.592 9h-2.221l-1.804-7h-9.42c.071.836.178 1.511-.107 2h-3.456c.292-.431.166-1.111.086-2h-.481l-1.739 7h-2.265zm5.101-6.631h2.298c-.157-1.076-.092-2.782.404-3.786h-2.249c-.553 1.006-.624 2.64-.453 3.786z"
                                />
                            </svg>
                            {priceParser(
                                Math.round(totalSummary.totalCostNoVat),
                            )}
                        </div>
                        <div className="icon">
                            <div className="hover-tooltip">
                                <div className="text">Kundens pris</div>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M10.81 11.885h-1.098l.066-.739h1.069l-.037.739zm.613 1.099h1.14l-.007-.739h-1.111l-.022.739zm.085-2.971l-.021.739h1.054l-.007-.739h-1.026zm-1.894 2.971h1.14l.038-.739h-1.112l-.066.739zm1.291-2.971h-1.026l-.066.739h1.054l.038-.739zm6.308 0l.137.739h1.054l-.165-.739h-1.026zm-4.115 0l.023.739h1.054l-.051-.739h-1.026zm1.155 1.872l-.051-.739h-1.069l.022.739h1.098zm3.309-4.885h-7.406l-.204 2h8.058l-.448-2zm-6.107 4.885h1.097l-.007-.739h-1.069l-.021.739zm2.874 1.099l-.051-.739h-1.111l.023.739h1.139zm-5.888-2.971h-1.025l-.134.739h1.054l.105-.739zm10.215 1.872l-.165-.739h-1.069l.136.739h1.098zm-12.074-.739h-1.069l-.179.739h1.097l.151-.739zm.231-1.133h-1.026l-.179.739h1.054l.151-.739zm17.187 4.987v7h-24v-7h24zm-2 2h-20v3h20v-3zm-9 1h-2v1h2v-1zm-7.932-5.016h1.14l.15-.739h-1.111l-.179.739zm11.702-2.233l-.121-.739h-1.026l.093.739h1.054zm.185 1.134l-.121-.739h-1.069l.093.739h1.097zm1.946 1.099l-.165-.739h-2.833l.093.739h2.905zm-10.622-1.838h-1.069l-.134.739h1.098l.105-.739zm-1.402 1.838h1.139l.105-.739h-1.11l-.134.739zm-5.595.016l2.621-9h1.921c.112-.622.322-1.371.668-2h3.427c-.26.57-.499 1.259-.627 2h10.805l2.592 9h-2.221l-1.804-7h-9.42c.071.836.178 1.511-.107 2h-3.456c.292-.431.166-1.111.086-2h-.481l-1.739 7h-2.265zm5.101-6.631h2.298c-.157-1.076-.092-2.782.404-3.786h-2.249c-.553 1.006-.624 2.64-.453 3.786z"
                                />
                            </svg>
                            {priceParser(
                                Math.round(totalSummary.customerPrice),
                            )}
                        </div>
                        <div
                            className={`icon ${
                                totalSummary.result > 0
                                    ? "is-positive"
                                    : "is-negative"
                            }`}
                        >
                            <div className="hover-tooltip">
                                <div className="text">Resultat</div>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4 14.083c0-2.145-2.232-2.742-3.943-3.546-1.039-.54-.908-1.829.581-1.916.826-.05 1.675.195 2.443.465l.362-1.647c-.907-.276-1.719-.402-2.443-.421v-1.018h-1v1.067c-1.945.267-2.984 1.487-2.984 2.85 0 2.438 2.847 2.81 3.778 3.243 1.27.568 1.035 1.75-.114 2.011-.997.226-2.269-.168-3.225-.54l-.455 1.644c.894.462 1.965.708 3 .727v.998h1v-1.053c1.657-.232 3.002-1.146 3-2.864z"
                                />
                            </svg>
                            {priceParser(Math.round(totalSummary.result))}
                        </div>
                    </div>
                )}
                {!!missingOrders?.length && (
                    <div className="missingOrders">
                        <table>
                            <thead>
                                <tr>
                                    <th>Transportör</th>
                                    <th>Trackingnummer</th>
                                    <th>Avsändare</th>
                                    <th>Mottagare</th>
                                    <th>Välj kund</th>
                                </tr>
                            </thead>
                            <tbody>
                                {missingOrders.map((order) => {
                                    return (
                                        <tr key={order.trackingNumber}>
                                            <td>{order.transporter}</td>
                                            <td>{order.trackingNumber}</td>
                                            <td>{order.sender}</td>
                                            <td>{order.recipient}</td>
                                            <td>
                                                <InputDropdown
                                                    searchable
                                                    onChange={(customerId) => {
                                                        if (!customerId) {
                                                            return;
                                                        }
                                                        pairOrder({
                                                            order,
                                                            customerId,
                                                        });
                                                    }}
                                                    options={customerList.map(
                                                        (customer) => {
                                                            return {
                                                                title: customer.name,
                                                                value: customer.id,
                                                            };
                                                        },
                                                    )}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                {!!customers?.length && (
                    <div className="customers">
                        {customers.map((customer) => {
                            return (
                                <Customer
                                    key={customer.id}
                                    customer={customer}
                                    orders={customer.orders}
                                    onChange={updateCustomer}
                                    moveOrder={moveOrder}
                                />
                            );
                        })}
                    </div>
                )}
            </Container>
        </FortnoxAuthenticator>
    );
}

function customerListSort(c1, c2) {
    if (numberOfInvoicedShipments(c1) && !numberOfInvoicedShipments(c2)) {
        return 1;
    }
    if (numberOfInvoicedShipments(c2) && !numberOfInvoicedShipments(c1)) {
        return -1;
    }
    if (c1.name?.toLowerCase() < c2.name?.toLowerCase()) {
        return -1;
    }
    if (c1.name?.toLowerCase() > c2.name?.toLowerCase()) {
        return 1;
    }
    return 0;
}

export default View;
